import React from "react";
import "./BottomAlert.css"; // Import the CSS file
import { getUser } from "../../Utils/isAuth";
import { Alert } from 'antd';

const BottomAlert = ({ autoClose = true, duration = 10000 }) => {
  const user = getUser();

  return (
    <Alert
      message="Access to all projects"
      description={`To get access to all projects, please sign the document sent to your email ${user?.email}.  If you have already signed, be patient changes will reflect in 2 to 3 minutes`}
      type="warning"
      showIcon
      closable
    />
  );
};

export default BottomAlert;
